const CatalogPromotionsActions = {
    SET_PROMOTIONS: 'SET_PROMOTIONS',
    LOAD_CATALOG_PROMOTIONS_ACTION: 'LOAD_CATALOG_PROMOTIONS_ACTION',
    SET_BUYER_ASSIST_URL: 'SET_BUYER_ASSIST_URL',
};

export { CatalogPromotionsActions };